<template>
	<div class="grey-back" :class="{'hasBigFooter':$root.isAppUpdateAvailable}">

    <div white-background class="mb-2 primary-border-color" @click="openHelpSheet" style="border-bottom: 0.5px #4b77be dotted;">
      <v-subheader class="video-link-tile primary-color" subheader-semi-dense grey-back>
        <!-- <img width="20" class="mr-3" src="../../../assets/icon_contact_support.svg" alt="contact_support"/> -->
        <v-icon color="primary" font20 class="mr-3">message</v-icon>
        Need Help? Contact us
        <v-spacer></v-spacer>
        <!-- Need Help? -->
        <v-icon color="primary" font20 class="ml-1">expand_more</v-icon>
      </v-subheader>
    </div>

    <div @click="fn_setDataDrive" flat class="alert-container pa-3 ma-3" style="border-radius: 8px;" v-if="$root.CurrentBusiness && !$root.CurrentBusiness.DataDrive && showInvoiceCard === false">
      <span><v-icon class="font18 mr-2">error</v-icon> Set Auto Data Backup</span>
      <v-spacer></v-spacer>
      <span font-medium><v-icon class="font20" style="vertical-align:middle;">chevron_right</v-icon></span>
    </div>

    <v-list class="alert_tile ma-3" style="border-radius: 5px;border: 0.5px #ffeeba solid;background: #fff3cd;" nopadding v-if="$root.CurrentBusiness && $root.CurrentBusiness.DataDrive && showInvoiceCard === false && (!$root.lastBackupDate || $root.lastBackupBefore && $root.lastBackupBefore >= 4)">
      <v-list-tile class="pt-1 pb-1" @click="fn_dataBackup" style="background: #fff3cd;color: #856404 !important;border-radius: 5px;border: 0.5px #856404 solid;">
        <v-list-tile-content>
          <v-list-tile-title style="font-size: 14px;font-weight: 500;">Data backup is pending</v-list-tile-title>
          <v-list-tile-sub-title style="color: #856404 !important;font-size: 12px;" v-if="$root.lastBackupDate">Last Backup: {{ $root.lastBackupDate | moment("DD-MMM-YYYY hh:mm a")}}</v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn style="color: #856404 !important;" flat small>Backup Now <v-icon style="color: #856404 !important">chevron_right</v-icon></v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>

    <transition name="fade" mode="out-in">
      <div v-if="showInvoiceCard" @click="fn_saleInvoice" white-background class="ma-3" style="border-radius: 10px;border: 0.5px solid rgb(221, 221, 221);padding: 12px;background: #ecf7f3 !important;border-color: #0f5132;">
        <div flat class="info-container pa-3" style="border-radius: 10px;background: #0f5132 !important;color: #fff !important;">
          <div><span class="mr-2" style="border:1px dotted;width:24px;border-radius: 50%;padding:2px 7px;">&#8377;</span> Add your first Sale Invoice</div>
          <v-spacer></v-spacer>
          <div font-medium><v-icon class="font20" style="vertical-align:middle;color: #fff !important;">chevron_right</v-icon></div>
        </div>
        <div class="right-align font-small" style="color: #0f5132;padding-top: 12px;"><span @click="fn_watchVideo">Watch Help Video <v-icon class="font14 ml-1" style="border:1px solid; border-radius: 50%;color: #0f5132 !important;">play_arrow</v-icon></span></div> 
      </div>
    </transition>

    <!-- <div whitecolor style="display: flex; margin: 16px;border-radius: 8px;background:#42A5F5;background-image: linear-gradient(to right, rgba(59,95,181,1), rgba(255,255,255,0.05));" class="pl-3 pr-3 pt-2 pb-2 ma-3">
      <span><v-icon class="whitecolor font18 mr-2">error</v-icon> Set Auto Data Backup</span>
      <v-spacer></v-spacer>
      <span font-medium>Setup Now <v-icon class="whitecolor font18" style="vertical-align:text-top;">chevron_right</v-icon></span>
    </div> -->

    <!-- <transition name="fade" mode="out-in">
        <v-card v-if="showInvoiceCard" @click.native="fn_saleInvoice" style="margin: 16px;border-radius: 8px;background:#42A5F5;background-image: linear-gradient(to right, rgba(59,95,181,1), rgba(255,255,255,0.05));">
          <v-card-text style="padding:16px 8px">
            <v-layout row wrap>
              <v-flex xs9 sm9 md9>
                <div class="pl-3" style="font-size: 16px;padding-top: 6px;font-weight: 500;color: #fff;">
                  <div style="font-size: 1.25rem;">Add your first transaction</div>
                  <v-btn flat color="primary" class="ml-0 mt-2 pl-2 pr-2" style="background-color: #fff !important;color: #3b5fb5 !important;border-radius: 5px;" capitalize small>
                    <span style="border-radius: 50%;border: 1px solid;width: 16px;height: 16px;margin-right: 6px;font-size: 10px;">₹</span>Add New Sale
                  </v-btn>
                </div>  
              </v-flex>
              <v-flex style="justify-content: right;display: flex;" xs3 sm3 md3>
                <div style="width: 68px;height:68px;margin: 6px 0px;">
                  <img style="width: 68px;height:68px;" src="../../../assets/Invoice_icon_v2-01.svg"/>
                </div>
              </v-flex>
            </v-layout>
            
          </v-card-text>
          <v-card-actions class="ml-3 mr-3 pl-0 pr-0" style="border-top: 1px rgba(255,255,255,0.5) dashed;">

            <v-layout row wrap>
              <v-flex xs6 sm6 md6>
                <v-btn @click="fn_watchVideo" flat color="primary" class="ma-0" style="color: rgba(255,255,255,0.72) !important;" capitalize small>
                  <v-icon font14 class="mr-1" style="color:rgba(255,255,255,0.72) !important;border:1px rgba(255,255,255,0.72) solid;border-radius: 50%;">play_arrow</v-icon>
                  Watch Help Video 
                </v-btn>
              </v-flex>

              <v-flex xs6 sm6 md6>
                <v-btn @click="fn_whatsappsupport" flat color="primary" class="ma-0" style="color: rgba(255,255,255,0.72) !important;" capitalize small>
                  <img width="20" class="mr-1" src="../../../assets/icon_contact_support_white.svg" alt="contact_support"/>
                  WhatsApp Support
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
    </transition> -->

		<v-list nopadding>

        <v-list-tile>
          <v-list-tile-content @click="fn_invoiceTileClick">
            <v-list-tile-title>Sale Invoice</v-list-tile-title>
          </v-list-tile-content>

          <v-list-tile-action @click="fn_invoiceTileClick(1)">
            <v-btn capitalize class="pl-2 pr-2" small style="border-radius: 5px;" color="primary">
              <span style="border-radius: 50%;border: 1px solid;width: 16px;height: 16px;margin-right: 6px;font-size: 10px;">₹</span> Add New Sale
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>

        <v-divider></v-divider>

          <div v-for="(item, index) in favouriteItems" :key="index">
            <v-list-tile>
              <v-list-tile-content @click="fn_openList(item)">
                <v-list-tile-title>{{item.title}}</v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action @click="fn_openForm(item)">
                <v-btn flat icon light color="primary">
                  <v-icon>add</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>

            <v-divider v-if="favouriteItems.length-1 != index"></v-divider>
          </div>

          <v-divider></v-divider>

          <v-list-tile @click="fn_dataBackup('manual')">
            <v-list-tile-content>
              <v-list-tile-title>Data Backup</v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-btn flat icon light color="primary">
                <v-icon>keyboard_arrow_right</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>

          <!-- <v-divider></v-divider>

          <v-list-tile to="/drafts">
            <v-list-tile-content>
              <v-list-tile-title>Drafts</v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-badge left v-if="draftCount">
                <span slot="badge">{{draftCount}}</span>
              </v-badge>
            </v-list-tile-action>
          </v-list-tile> -->
          

        </v-list>

        <v-list nopadding class="ma-3">
          <v-subheader subheader-ultra-dense class="pl-0 grey-back"><v-icon font16 class="mr-2">info_outline</v-icon> Turn On for Desktop Access</v-subheader>
          <v-list-tile class="padding-right-0" style="background-color: #42A5F5;color: #fff;border-radius: 5px;">
            <v-list-tile-content>
              <v-list-tile-title>Mobile Server</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-switch v-model="dataService" @change="fn_toggleService" class="server_switch"></v-switch>
              <!-- <v-menu left>
                <v-btn style="margin: -2px -6px;" slot="activator" icon><v-icon style="color: #fff !important;">more_vert</v-icon></v-btn>
                  <v-list nopadding dense>
                    <v-list-tile to="/settings/connectionrequest/servicetimer">
                        <v-list-tile-title>Set Timer</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
              </v-menu> -->
            </v-list-tile-action>
          </v-list-tile>
        </v-list>

        <!-- <div @click="fn_setDataDrive" flat class="alert-container pa-3 ma-3" style="border-radius: 8px;" v-if="$root.CurrentBusiness && !$root.CurrentBusiness.DataDrive && (showInvoiceCard !== null && !showInvoiceCard)">
          <span><v-icon class="font18 mr-2">error</v-icon> Set Auto Data Backup</span>
          <v-spacer></v-spacer>
          <span font-medium><v-icon class="font20" style="vertical-align:middle;">chevron_right</v-icon></span>
        </div>

        <transition name="fade" mode="out-in">
          <div v-if="showInvoiceCard" @click="fn_saleInvoice" white-background class="ma-3" style="border-radius: 8px;">
            <div flat class="info-container pa-3" style="border-radius: 8px;">
              <div><span class="mr-2" style="border:1px dotted;width:24px;border-radius: 50%;padding:2px 7px;">&#8377;</span> Add your first Sale Invoice</div>
              <v-spacer></v-spacer>
              <div font-medium><v-icon class="font20" style="vertical-align:middle;">chevron_right</v-icon></div>
            </div>
          </div>
        </transition> -->

        <div white-background id="invoice_setting_alert" v-if="$root.isAppUpdateAvailable" font14 style="position: fixed;bottom: 0px;width:100%;">
					<div class="pt-2 pb-2 pl-3 font-medium" style="display: flex;background-color: #E0E0E0 !important;color: rgba(0,0,0,0.54);">
						<!-- <span>Want to customise this Invoice Print?</span> -->
						<span @click="fn_openPlayStore">App update available on Google Play Store<br> <span class="primary-color">Update Now</span> <v-icon color="primary" font20 style="margin-left: -6px;line-height: 16px;">chevron_right</v-icon></span>
						<!-- <span>Tap on <v-icon color="primary" font20>settings</v-icon> in the header and customise the invoice template as per your needs.</span> -->
						<v-spacer></v-spacer>
						<!-- <v-icon font20>close</v-icon> -->
            <v-btn small flat capitalize font14 style="min-width: auto;opacity: 0.6;" @click="$root.isAppUpdateAvailable=false">Later</v-btn>
					</div>
				</div>

        <!-- <v-btn color="success" @click="fn_getUserId">start</v-btn> -->

        <!-- <v-list class="mt-3" nopadding>
          <v-list-tile style="background-color: #ddd;">
            <v-list-tile-action>
              <v-switch v-model="dataService" @change="fn_toggleService"></v-switch>              
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Mobile Server</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-menu>
                <v-btn slot="activator" icon><v-icon>more_horiz</v-icon></v-btn>
                  <v-list nopadding dense>
                    <v-list-tile>
                        <v-list-tile-title>Set Timer</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
              </v-menu>
            </v-list-tile-action>
          </v-list-tile>
        </v-list> -->
        

	</div>
</template>

<script>

// import dialogDriveAlert from '../../transactions/forms/dialogs/dialog_drive_alert'

  export default{
    name: "favourites",
    props:['showInvoiceCard', 'openHelpSheet'],
    // props:['draftCount'],
    // components:{
    //   'dialog-drive-alert':dialogDriveAlert
    // },
    data(){
      return{
        dataService:false,
        draftItemsCount:0,
        favouriteItems:[
          // {
          //   "id":1, 
          //   "title":"Sale Invoice",
          //   "uri":"/transactions/sales/saleinvoice/items",
          //   "routeName":"",
          //   "type":"transaction"
          // },
          {
            "id":2, 
            "title":"Order",
            "uri":"/transactions/sales/order/items",
            "routeName":"",
            "type":"transaction"
          },
          {
            "id":3, 
            "title":"Estimate/Quotation",
            "uri":"/transactions/sales/estimate/items",
            "routeName":"",
            "type":"transaction"
          },
          {
            "id":4, 
            "title":"Purchase Invoice",
            "uri":"/transactions/purchase/purchaseinvoice/items",
            "routeName":"",
            "type":"transaction"
          },
          {
            "id":5, 
            "title":"Expense",
            "uri":"/transactions/purchase/expense/items",
            "routeName":"",
            "type":"transaction"
          },
          // {
          //   "id":5, 
          //   "title":"Customer",
          //   "uri":"/masters/accounts/ledgers/items",
          //   "routeName":"ledgerItems",
          //   "groupTypeId":101
          // },
          {
            "id":6, 
            "title":"Customer",
            "uri":"/masters/accounts/ledgers/items",
            "routeName":"ledgerItems",
            "groupTypeId":101,
            "type":"master"
          },
          // {
          //   "id":6, 
          //   "title":"Supplier",
          //   "uri":"/masters/accounts/ledgers/items",
          //   "routeName":"ledgerItems",
          //   "groupTypeId":102
          // },
          {
            "id":7, 
            "title":"Supplier",
            "uri":"/masters/accounts/ledgers/items",
            "routeName":"ledgerItems",
            "groupTypeId":102,
            "type":"master"
          },
          {
            "id":8, 
            "title":"Items",
            "uri":"/masters/inventory/productandservices/items",
            "routeName":"productAndServiceItems",
            "type":"master"
          },
          {
            "id":9, 
            "title":"Payment In",
            "uri":"/transactions/receipt/items",
            "routeName":"",
            "type":"transaction"
          },
          {
            "id":10, 
            "title":"Payment Out",
            "uri":"/transactions/payment/items",
            "routeName":"",
            "type":"transaction"
          },
        ]
      }
    },
    methods:{
      fn_openList: function(item){
        if(item.routeName){
          // this.$router.push({name:item.routeName, query:{tagId:this.guidWeb(), groupType:item.title}, params: { 'isNew': 1 }});
          if(item.groupTypeId){
            this.$router.push({name:item.routeName, query:{tagId:this.guidWeb()}, params: { 'isNew': 1, 'groupTypeId': item.groupTypeId}});  
          }
          else{
            this.$router.push({name:item.routeName, query:{tagId:this.guidWeb()}, params: { 'isNew': 1 }});  
          }
        }
        else{
          this.$router.push({path:item.uri, query:{tagId:this.guidWeb()}});
        }
      },
      
      fn_openForm: function(item){
        item.type == "transaction" ? localStorage.setItem("SetDataDrive", 1) : '';

        if(item.groupTypeId){
          this.$router.push({path:item.uri+'/new', query:{tagId:this.guidWeb(), groupTypeId:item.groupTypeId}});
        }
        else{
          this.$router.push({path:item.uri+'/new', query:{tagId:this.guidWeb()}});
        }
      },

      fn_saleInvoice: function(){
        let postObj = {"eventName":"first_invoice_card_click","eventData":[{"eventKey":"card_click","eventValue":"SaleInvoice"}]}
        this.$root.fn_postMetrics(postObj);
        this.$router.push({path:'/transactions/sales/saleinvoice/items/new', query:{tagId:this.guidWeb()}});
      },

      fn_invoiceTileClick: function(addNewBtn){
        if(this.showInvoiceCard || addNewBtn === 1){
          this.$router.push({path:'/transactions/sales/saleinvoice/items/new', query:{tagId:this.guidWeb()}});
        }
        else{
          this.$router.push({path:"/transactions/sales/saleinvoice/items", query:{tagId:this.guidWeb()}})
        }
      },

      fn_watchVideo: function(event){
        event.stopPropagation();
        if(this.$root.CurrentBusiness){
          if(this.$root.CurrentBusiness.GSTRegistrationStatus == 1){
            this.$root.fn_openExternalUrl("https://www.youtube.com/watch?v=GoQsSgLuavI");
          }
          else if(this.$root.CurrentBusiness.GSTRegistrationStatus == 2){
            this.$root.fn_openExternalUrl("https://www.youtube.com/watch?v=dN163AnsNkw");
          }
          else if(this.$root.CurrentBusiness.GSTRegistrationStatus == 3){
            this.$root.fn_openExternalUrl("https://www.youtube.com/watch?v=Mp8RVGkeJJ0");
          }
        }
      },

      fn_setDataDrive: function(){
        if(!navigator.onLine){
          this.showToast("Internet not available");
          return;
        }

        this.$router.push({path:"/registration/business/setupdrive"});
      },

      fn_dataBackup: function(type){
        if(this.$root.CurrentBusiness && this.$root.CurrentBusiness.DataDrive){
          if(type == 'manual'){
            this.$router.push({path:"/settings/backup"});
          }
          else{
            this.$router.push({path:"/settings/backup", query:{"auto_start":1}});
          }
        }
        else{
            this.$router.push({path:"/registration/business/setupdrive"});
        }
        // this.$router.push({path:"/settings/backup", query:{"auto_start":1}});
      },

      fn_openPlayStore: function(){
        // this.$root.isAppUpdateAvailable = false;
        this.getData("OpenPlayStore", null, 
            {
                onSuccess: function(response){
                    console.log(response);
                }, 
                onError: function(error){
                    console.log(error);
                }
            }
        );
      },

      fn_toggleService: function(val){
        if(val){
          this.fn_getUserId();
        }
        else{
          this.fn_stopService();
        }
      },

      fn_stopService: function(){
				var self = this;
        this.getData('CloseWebRTCService', null, 
          {
            onSuccess: function(response){
              console.log(response);
              self.showToast("Service stopped");
            },
            onError: function(error){
              console.log(error);
              self.dataService = true;
              self.showToast('Something went wrong. Try again!.')
            }
        });
			},
      
      fn_getUserId: function(){
        let self = this;
        this.getData("GetUserId", null, 
            {
                onSuccess: function(response){
                    console.log(response);
                    self.fn_startMobileServer(response)
                }, 
                onError: function(error){
                    console.log(error);
                }
            }
        );
      },

      fn_startMobileServer: function(userId){

        let dataObj = {
          "businessId":this.$root.CurrentBusiness.BusinessID, 
          "businessName":this.$root.CurrentBusiness.BusinessName,
          "userId":userId,
          "startService":true
        }

        this.postData('StartMobileServer', dataObj, 
          {
              onSuccess: function(response){
                console.log(response);
              }, 
              onError: function(error){
                console.log(error);
              }
          }
        );
      },

      // fn_whatsappsupport: function(event){
      //   event.stopPropagation();
      //   this.$root.fn_openExternalUrl('https://api.whatsapp.com/send?phone=918882741212');
      // }
    }
  }
</script>

<style>
.server_switch .v-input--switch__track{
  color: #fefefe !important;
}
.server_switch .v-input--switch__track.accent--text{
  color: rgba(0,0,0,.38) !important;
}
.server_switch .v-input--switch__thumb.accent--text{
  color: #ddd !important;
}
</style>


// WEBPACK FOOTER //
// src/components/actions/contents/favourites.vue